<template>
  <div class="gold-banner-slot">
    <div class="container">
      <NuxtLink
        class="gold-banner-link"
        :to="{
          name: 'language-area-gold',
          params: {
            language: route.params.language,
          },
        }"
      >
        <picture>
          <source media="(max-width: 769px)" :srcset="imageMobile" />
          <img :src="imageDesktop" :alt="translate.bannerAlt" />
        </picture>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import imageDesktopPt from "@/assets/img/area-gold-banner-desktop-pt.webp";
import imageDesktopEn from "@/assets/img/area-gold-banner-desktop-en.webp";
import imageMobilePt from "@/assets/img/area-gold-banner-mobile-pt.webp";
import imageMobileEn from "@/assets/img/area-gold-banner-mobile-en.webp";
import translateMain from "@/tradutors/areagold";

const route = useRoute();

const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);

const imageDesktop = computed(() =>
  route.params.language === "pt-br" ? imageDesktopPt : imageDesktopEn
);

const imageMobile = computed(() =>
  route.params.language === "pt-br" ? imageMobilePt : imageMobileEn
);
</script>

<style scoped lang="css">
/* O banner flutua sobre a divisão claro/preto entre o Blog e os Vídeos: a altura
   de conteúdo é zero e a imagem é puxada meia altura para cima, de modo que o
   centro dela cai exatamente na fronteira sem depender da altura renderizada
   (que é fluida abaixo de 1310px). O padding-top é a folga acima da fronteira. */
.gold-banner-slot {
  height: 0; /* box-sizing: border-box -> altura no fluxo = padding-top */
  padding-top: 100px;
  z-index: 3; /* acima do .dark-rounded (z-index: 1) */
  background: #fff;
}

.gold-banner-slot .container {
  display: flex;
  justify-content: center;
}

.gold-banner-link {
  display: block; /* inline + reset global `* { position: relative }` gera baseline gap */
  width: 100%;
  /* -50% centraliza na base do slot; o + desce até o fim do .videos-gray-cap.
     O deslocamento fica no conteúdo (e não no slot, via `top`) para que o fundo
     do slot pare na base do fluxo e não cubra a tampa de cantos arredondados. */
  transform: translateY(calc(-50% + 24px));
}

.gold-banner-slot img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 1230 / 150; /* evita CLS sem width/height fixos */
  cursor: pointer;
}

/* === Tablet/iPad (770–1199px) === */
@media screen and (min-width: 770px) and (max-width: 1199px) {
  .gold-banner-slot {
    padding-top: 70px;
  }
}

@media screen and (max-width: 769px) {
  .gold-banner-slot {
    padding-top: 60px;
    background: #f0f0f0; /* no mobile o fundo do blog/vídeos é cinza, não branco */
  }

  .gold-banner-link {
    width: 95%; /* mesma largura do BannerEnsaioGratis */
    transform: translateY(calc(-50% + 20px)); /* tampa de 20px no mobile */
  }

  .gold-banner-slot img {
    aspect-ratio: 1230 / 333;
  }
}
</style>
